/* eslint-disable @typescript-eslint/no-explicit-any */
const VALIDATION_ERROR_STATUSES = [400, 422];

function isValidationError(status: any) {
  return VALIDATION_ERROR_STATUSES.includes(status);
}

function parseResponse(
  isValidationError: any,
  httpStatus: any,
  responseText: any
) {
  if (!responseText || /^\s*$/.test(responseText)) {
    return { isValidationError, httpStatus, ok: true };
  }
  let result = {};
  try {
    result = JSON.parse(responseText);
  } catch (e) {
    result = { responseText };
  }
  return { isValidationError, httpStatus, ok: true, data: result };
}

function isFunction(obj: any) {
  return typeof obj === 'function';
}

const RESPONSE_ARG_ERROR =
  'Response should be defined and should have #text()[Promise]';

export function handleHttpErrors(response: any) {
  if (!response || !isFunction(response.text)) {
    throw new Error(RESPONSE_ARG_ERROR);
  }
  const responseTextPromise = response.text();
  if (!isFunction(responseTextPromise.then)) {
    throw new Error(RESPONSE_ARG_ERROR);
  }
  if (response.status === 401) {
    if (!/\/signin/.test(window.location.pathname)) {
      window.location.replace('/signin');
    }
  }
  return responseTextPromise.then((responseText: string) =>
    Promise.reject({
      error: true,
      ok: false,
      httpStatus: response.status,
      responseBody: responseText
    })
  );
}

export function jsonResponse(response: any) {
  const status = response.status;

  if (response.ok || isValidationError(status)) {
    return response
      .text()
      .then((body: any) =>
        parseResponse(isValidationError(status), status, body)
      );
  }
  return handleHttpErrors(response);
}

export function mergeOptions(fetchOptions: any) {
  const headerOpts: Record<string, string> = {
    accept: 'application/json',
    pragma: 'no-cache',
    'cache-control': 'no-cache, no-store, must-revalidate'
  };
  // Only with a body. Fastify rejects `content-type: application/json` with an
  // empty body (FST_ERR_CTP_EMPTY_JSON_BODY), so every DELETE — customers,
  // locations, services — and every body-less POST answered 400.
  if (fetchOptions.body !== undefined) headerOpts['content-type'] = 'application/json';
  const headers = fetchOptions.headers || {};
  return {
    credentials: 'same-origin',
    ...fetchOptions,
    headers: { ...headerOpts, ...headers }
  };
}
